import { toast } from 'react-hot-toast';
import { FaCheck } from 'react-icons/fa';
import { ImCross } from 'react-icons/im';

const Success = (message: string) => {
  toast.remove();
  toast.custom(t => (
    <div
      className={`
        bg-[#179645ff] text-white  
        px-4 sm:px-6 md:px-10 lg:px-10
        py-3 rounded-md font-medium
        flex items-center gap-3 shadow-lg font-poppins text-base
        ${t.visible ? 'animate-enter' : 'animate-enter'}
      `}
    >
      <FaCheck className='text-white border-2 h-6 w-6 border-white p-1 rounded-full text-xl font-semibold' />
      <span>{message}</span>
    </div>
  ));
};

const Error = (message: string) => {
  toast.remove();
  toast.custom(t => (
    <div
      className={`
        bg-[#C12E2A] text-white 
        px-4 sm:px-6 md:px-10 lg:px-10
        py-3 rounded-md font-medium
        flex items-center gap-3 shadow-lg font-poppins text-base
        ${t.visible ? 'animate-enter' : 'animate-leave'}
      `}
    >
      <ImCross className='text-white border-2 h-6 w-6 border-white p-1 rounded-full text-xl font-semibold' />
      <span>{message}</span>
    </div>
  ));
};

const SuccessOld = (message: string) => {
  toast.success(message, {
    icon: <FaCheck className='text-white' />,
    position: 'top-center',
    duration: 3000,
    style: {
      background: '#179645ff',
      color: '#ffffff',
    },
  });
};

const ErrorOld = (message: string) => {
  toast.success(message, {
    icon: <ImCross className='text-white' />,
    position: 'top-center',
    duration: 3000,
    style: {
      background: '#C12E2A',
      color: '#ffffff',
      paddingLeft: '40px',
      paddingRight: '40px',
    },
  });
};

const Warning = (message: string) => {
  toast.remove();
  toast(message, {
    icon: '⚠️',
    position: 'top-right',
    duration: 3000,
  });
};
export const ToasterService = {
  Warning,
  Error,
  Success,
  SuccessOld,
  ErrorOld,
};
